/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";

import { Formik, Field } from "formik";
import * as Yup from "yup";
import Alert from "../../shared/components/Alert";

import FormField from "../../shared/components/form/FormField";
import { forgotpassword, resetpassword } from "../../actions/auth/authAction";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Row,
  Col,
  UncontrolledTooltip,
  Nav,
  NavItem,
  Button,
  Badge
} from "reactstrap";
import { NavLink as NavLinkStrap } from "reactstrap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import {
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { openSocialLink } from "../../helpers";

import hero8 from "../../assets/images/hero-bg/hero-15.jpg";
import logo from "../../assets/images/logo.png";

const initialValues = { password: "", cpassword: "" };
const validationSchema = Yup.object({
  password: Yup.string("")
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your password"),
  cpassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match")
    .required("Confirm your required")
});

class ResetPassword extends PureComponent {
  state = {
    loading: false,
    success: null,
    error: null,
    showPassword: false,
    showConfirm: false
  };
  // resetForm;

  showPassword = e => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword
    });
  };

  showConfirm = e => {
    e.preventDefault();
    this.setState({
      showConfirm: !this.state.showConfirm
    });
  };

  handleResendEmail = e => {
    e.preventDefault();
    const queryParams = queryString.parse(this.props.location.search);
    this.setState({ loading: true, error: null, success: null }, () => {
      if (queryParams.email) {
        this.props.forgotPassword({
          email: queryParams.email.replace(" ", "+"),
          user_role: "user"
        });
      }
    });
  };

  handleSubmit = values => {
    const queryParams = queryString.parse(this.props.location.search);
    this.setState({ loading: true, error: null, success: null });
    this.props.resetpassword({
      password: values.password,
      email: queryParams.email.replace(" ", "+"),
      activation: queryParams.activation
    });
  };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) this.props.history.push("/");
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.auth.isForgotPasswordSuccess === true) {
      return { loading: false, success: nextProps.auth.message, error: null };
    } else if (nextProps.auth.isForgotPasswordSuccess === false) {
      return { loading: false, error: nextProps.auth.error, success: null };
    }
    if (nextProps.resetPasswordState.resetPasswordSuccess === true) {
      setTimeout(() => nextProps.history.push("/login"), 1000);
      return {
        loading: false,
        success: nextProps.resetPasswordState.message,
        error: null
      };
    } else if (nextProps.resetPasswordState.resetPasswordSuccess === false)
      return {
        loading: false,
        error: nextProps.resetPasswordState.error,
        success: null
      };
  }

  render() {
    let alertContent;
    if (this.state.error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered" icon>
          {this.state.error}
          {this.state.error === "Reset password link has expired" && (
            <a href="/" onClick={this.handleResendEmail}>
              Resend verification email
            </a>
          )}
        </Alert>
      );
    } else if (this.state.success) {
      alertContent = (
        <Alert color="success" className="alert--bordered" icon>
          <p>{this.state.success}</p>
        </Alert>
      );
    }

    return (
      <div className="app-wrapper min-vh-100 bg-white">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <Row className="min-vh-100 no-gutters">
                    <Col lg="7" xl="6" className="d-flex align-items-center">
                      <Col md="10" lg="8" xl="7" className="mx-auto">
                        {alertContent}
                        <Formik
                          initialValues={initialValues}
                          validationSchema={validationSchema}
                          onSubmit={this.handleSubmit}
                        >
                          {props => {
                            const {
                              handleSubmit,
                              errors /* resetForm */
                            } = props;
                            // this.resetForm = resetForm;
                            return (
                              <div className="bg-white rounded my-4">
                                <div className="text-center my-3">
                                  <img
                                    src={logo}
                                    width="250px"
                                    alt="BetterCapital.US"
                                  />
                                  <p className="font-size-lg text-center my-3 text-black-50">
                                    Built for Landlords, by landlords.{" "}
                                    <Badge color="primary">Track</Badge>
                                    {" - "}
                                    <Badge color="success">Learn</Badge>
                                    {" - "}
                                    <Badge color="warning">Grow</Badge>
                                  </p>
                                </div>

                                <h1 className="display-4 text-center mb-3 font-weight-bold">
                                  Reset Password
                                </h1>

                                <form className="form" onSubmit={handleSubmit}>
                                  <p style={{ color: "red" }}>
                                    {errors && errors.password}
                                  </p>

                                  <div className="form-group">
                                    <Field
                                      name="password"
                                      component={FormField}
                                      className="input-lg"
                                      type={"password"}
                                      placeholder="Password"
                                    />
                                  </div>

                                  <div className="form-group">
                                    <Field
                                      name="cpassword"
                                      component={FormField}
                                      type={"password"}
                                      placeholder="Confirm password"
                                    />
                                  </div>

                                  <div className="col-12 text-center my-4 ">
                                    <Button
                                      className="col-10 btn btn-primary px-5"
                                      color="primary"
                                      disabled={this.props.loading}
                                      type="submit"
                                    >
                                      {this.props.loading
                                        ? "Please wait..."
                                        : "Reset"}
                                    </Button>
                                  </div>
                                </form>
                              </div>
                            );
                          }}
                        </Formik>
                      </Col>
                    </Col>
                    <Col lg="5" xl="6" className="d-flex">
                      <div className="hero-wrapper w-100 bg-composed-wrapper bg-premium-dark min-vh-lg-100">
                        <div className="flex-grow-1 w-100 d-flex align-items-center">
                          <div
                            className="bg-composed-wrapper--image opacity-5"
                            style={{ backgroundImage: "url(" + hero8 + ")" }}
                          />
                          <div className="bg-composed-wrapper--bg bg-second opacity-6" />
                          <div className="bg-composed-wrapper--bg bg-deep-blue opacity-2" />
                          <div className="bg-composed-wrapper--content text-center p-5">
                            <div className="text-white px-0 px-lg-2 px-xl-4">
                              <h1 className="display-3 mb-4 font-weight-bold">
                                Take control of your real estate investments
                              </h1>
                              <p className="display-4 mb-0 opacity-8">
                                BetterCapital.us is a great, easy way to keep
                                track of all your investments, whether they're
                                paying off or not.
                              </p>
                              <div className="divider mx-auto border-1 my-5 border-light opacity-2 rounded w-25" />
                              <div>
                                <Button
                                  color="success"
                                  className="px-5 font-size-sm font-weight-bold btn-animated-icon text-uppercase rounded shadow-none py-3 hover-scale-sm hover-scale-lg"
                                >
                                  <span className="btn-wrapper--label">
                                    Intro Video
                                  </span>
                                  <span className="btn-wrapper--icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hero-footer pb-4">
                          <Nav pills className="nav-neutral-secondary">
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("facebook")}
                                className="font-size-lg text-white-50"
                                id="FacebookTooltipExample7"
                              >
                                <FontAwesomeIcon icon={faFacebook} />
                              </NavLinkStrap>
                              <UncontrolledTooltip
                                target="FacebookTooltipExample7"
                                container="body"
                              >
                                Facebook
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("twitter")}
                                className="font-size-lg text-white-50"
                                id="btnTwitterTooltip"
                              >
                                <FontAwesomeIcon icon={faTwitter} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnTwitterTooltip">
                                Twitter
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("youtube")}
                                className="font-size-lg text-white-50"
                                id="btnGoogleTooltip"
                              >
                                <FontAwesomeIcon icon={faYoutube} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnGoogleTooltip">
                                YouTube
                              </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                              <NavLinkStrap
                                href="#/"
                                onClick={e => openSocialLink("instagram")}
                                className="font-size-lg text-white-50"
                                id="btnInstagramTooltip"
                              >
                                <FontAwesomeIcon icon={faInstagram} />
                              </NavLinkStrap>
                              <UncontrolledTooltip target="btnInstagramTooltip">
                                Instagram
                              </UncontrolledTooltip>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.login,
  resetPasswordState: state.resetPassword
});
const mapDispatchToProps = dispatch => ({
  resetpassword: userData => resetpassword(userData, dispatch),
  forgotPassword: userData => forgotpassword(userData, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResetPassword));
